import React from "react";
import { ExitSurveyEmployee } from "./ExitSurveyEmployee";
import { ExitSurveyAPIResponse, ExitSurveyQuestion } from "../../../types/exitSurvey";

interface ExitSurveyProps {
  data?: ExitSurveyAPIResponse;
}

export const ExitSurvey: React.FC<ExitSurveyProps> = ({ data }) => {
  // Early return if no data is provided
  if (!data) {
    return (
      <div className="flex w-full max-w-[768px] flex-col items-start justify-end gap-1 rounded-lg bg-default-background">
        <ExitSurveyEmployee
          type="Employee"
          status="not_started"
          questions={[]}
        />
        <ExitSurveyEmployee
          type="HRBP"
          status="not_started"
          questions={[]}
        />
      </div>
    );
  }

  // Transform API data to match component expectations
  const transformData = (type: 'employee' | 'hrbp') => {
    // Return default values if data is not available
    if (!data?.[type]) {
      return { completed: false, questions: [], typeform_uri: undefined };
    }

    // Check if responses exist and is an array
    const responses = data[type].responses;
    if (!responses || !Array.isArray(responses)) {
      return { 
        completed: Boolean(data[type].completed), 
        questions: [], 
        typeform_uri: data[type].typeform_uri || undefined 
      };
    }

    // Transform responses with proper null checks
    const questions: ExitSurveyQuestion[] = responses
      .filter(response => response && typeof response === 'object') // Filter out null/undefined responses
      .map((response: any, index: number) => ({
      id: response.response_id?.toString() || index.toString(),
        question: response.question || 'No question provided',
      type: response.type === 'free_response' ? 'text' : 'single',
        answer: response.response || '',
      options: [] // API doesn't provide options, so we'll use empty array
    }));

    return {
      completed: Boolean(data[type].completed),
      questions,
      typeform_uri: data[type].typeform_uri || undefined
    };
  };

  const employeeData = transformData('employee');
  const hrbpData = transformData('hrbp');

  return (
    <div className="flex w-full max-w-[768px] flex-col items-start justify-end gap-1 rounded-lg bg-default-background">
      <ExitSurveyEmployee
        type="Employee"
        status={employeeData.completed ? 'completed' : 'pending'}
        questions={employeeData.questions}
      />
      <ExitSurveyEmployee
        type="HRBP"
        status={hrbpData.completed ? 'completed' : 'pending'}
        questions={hrbpData.questions}
        surveyLink={hrbpData.typeform_uri}
      />
    </div>
  );
}; 